import { render, staticRenderFns } from "./KeptFormerIchraBadge.vue?vue&type=template&id=ee4d9eec&lang=pug"
import script from "./KeptFormerIchraBadge.vue?vue&type=script&lang=js"
export * from "./KeptFormerIchraBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports